import React, { useState, useEffect } from "react";
import axios from "axios";
import ReactDOM from "react-dom";
import { setGlobalVariable } from "../shared";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "font-awesome/css/font-awesome.min.css";
import { Accordion } from "rsuite";
import ResultDetail from "./resultDetail";
import "../App.css";
import "./StudentResults.css";
import "./GridColorCodes.css";
import CompanionQuestions from "./CompanionQuestions";
import { json } from "react-router-dom";
import { useGlobalState } from '../state/index';

const StudentResults = ({
  rowData,
  newReultData,
  colDefs,
  defaultColDef,
  loadingResults,
  activeTab,
  baseUrl,
  resultData,
  yearFilter,
  currentYear,
  setCurrentYear,
  handleSelectedYear,
  selectedProduct,
  productList,
  getProductList,
  handleClickResult,
  loadingDetail,
  assessmentResultByItem,
  assessmentDetail,
  handleClickLIONResult,
  studntIdData,
  DOB
}) => {
  const leftArrow = require("../icons/arrowRight.png");
  const downArrow = require("../icons/downarrow.png");

  const [seAccessReadOnly] = useGlobalState("SEAccessReadOnly");

  const [assessmentResult, setassessmentResult] = useState(
    assessmentResultByItem
  );
  const [activeTabs, setActiveTabs] = useState(selectedProduct); // Track active tab

  const [showScrollIndicator, setShowScrollIndicator] = useState(false);
  const [isCompanionPopupOpen, setIsCompanionPopupOpen] = useState(false);
  const [companionQuestionData, setCompanionQuestionData] = useState(null);
  const [isCompanionLoading, setIsCompanionLoading] = useState(false);

  
  //Down arrow
  useEffect(() => {
    const scrollContainer = document.querySelector(".main-content");
    if (!scrollContainer) return;

    const handleScroll = () => {
      const bottom =
        scrollContainer.scrollTop + scrollContainer.clientHeight >=
        scrollContainer.scrollHeight - 10;
      setShowScrollIndicator(!bottom);
    };

    scrollContainer.addEventListener("scroll", handleScroll);

    const resizeObserver = new ResizeObserver(() => {
      requestAnimationFrame(handleScroll);
    });

    resizeObserver.observe(scrollContainer);

    requestAnimationFrame(handleScroll);

    return () => {
      scrollContainer.removeEventListener("scroll", handleScroll);
      resizeObserver.disconnect();
    };
  }, []);

  useEffect(() => {
    if (productList && productList.length > 0) {
      getProductList(productList[0]);
    }
  }, [productList]);

  useEffect(() => {
    setassessmentResult(assessmentResultByItem);
  }, [assessmentResultByItem]);

  const resultDataSet = {};
  for (const item of resultData) {
    if (item.Product == selectedProduct) {
      if (item.Subject in resultDataSet) {
        resultDataSet[item.Subject].push(item);
      } else {
        resultDataSet[item.Subject] = [item];
      }
    }
  }

  const renderProduct = () => {
    return (
      <div className="subject-row" translate="no">
{productList.map((product, index) =>
  product !== "Details" ? (
    <button
      key={`${product}-${index}`}
      className={`subject-button ${product} ${
        selectedProduct === product ? "active" : ""
      }`}
      onClick={() => getProductList(product)}
    >
      {product}
    </button>
  ) : (
    <button
      key={`${product}-${index}`}
      className={`subject-button ${product} ${
        selectedProduct === product ? "active" : ""
      }`}
      style={{ display: "none" }}
    >
      {product}
    </button>
  )
)}
      </div>
    );
  };

  const thumbsUp = require("../icons/thumbsup.png");
  const thumbsDown = require("../icons/thumbsdown.png");

  const stopGridClick = (event) => {
    if (!event) return;
    event.stopPropagation();
  };

  const fetchCompanionQuestions = (rowData) => {
    const studentkey = sessionStorage.getItem("studentkey");
    const districtID = sessionStorage.getItem("districtID");
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      return;
    }

    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    setIsCompanionLoading(true);
    axios
      .get(
        baseUrl +
          `Student/GetCompanionQuestions?studentkey=${studentkey}&districtId=${districtID}&assessmentKey=${rowData.IbeReleaseKey}`,
        { headers }
      )
      .then((response) => {
        setCompanionQuestionData(response.data);
        setIsCompanionPopupOpen(true);
      })
      .catch((error) => {
        console.error("Error fetching Data:", error);
      })
      .finally(() => {
        setIsCompanionLoading(false);
      });
  };


  const iconButtonStyle = {
    border: "none",
    background: "transparent",
    padding: 0,
    margin: 0,
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const scaleScore = (props) => {
    const className = props.data.Product === "LION" ? "" : "left";
    const { PerformanceChange, PerformanceExplain } = props.data;

    const renderPerformanceIcon = () => {
      if (PerformanceChange === null || PerformanceChange === undefined || typeof PerformanceChange !== "string" || PerformanceChange.trim() === "") return null;
      if (PerformanceChange === "Improved" || PerformanceChange === "Same") {
        return (
          <img
            src={thumbsUp}
            alt="Improved"
            height={20}
            width={20}
            style={{ marginRight: "4px", verticalAlign: "middle" }}
          />
        );
      }
      if (PerformanceChange === "Declined") {
        return (
          <img
            src={thumbsDown}
            alt="Declined"
            height={24}
            width={24}
            style={{ marginRight: "4px", verticalAlign: "middle" }}
          />
        );
      }
      return null;
    };

    return (
      <div title={PerformanceExplain || undefined}>
        {renderPerformanceIcon()}
        {props.data.ScaleScore && (
          <span className={className}>{props.data.ScaleScore}</span>
        )}
      </div>
    );
  };

  const score = (props) => {
    return (
      <div>
        {props.data.Score && (
          <span className={`center`}>{props.data.Score}</span>
        )}
      </div>
    );
  };

  const rawScore = (props) => {
    const className = selectedProduct === "LION" ? "" : "right";

    return (
      <div>
        {props.data.RawScore && (
          <span className={className}>{props.data.RawScore}</span>
        )}
      </div>
    );
  };

  const outCome = (props) => {
    const className = selectedProduct === "LION" ? "" : "right";

    return (
      <div>
        {props.data.FormVersion && (
          <span className={className}>{props.data.FormVersion}</span>
        )}
      </div>
    );
  };

  const resultDetail = (props) => {
    return (
      <div>
        {props.data.Product == "KENTRO" && (
          <span className="leftArrow">
            <button
              type="button"
              style={iconButtonStyle}
              onPointerDown={(e) => {
                stopGridClick(e);
                handleClickResult(props.data);
              }}
            >
              <img
                src={leftArrow}
                alt="Log In Icon"
                height={34}
                width={34}
                className="icon"
              />
            </button>
          </span>
        )}

        {props.data.LionResultsID != null &&
          props.data.Subject == "Mathematics" && (
            <span className="leftArrow">
              <button
                type="button"
                style={iconButtonStyle}
                onPointerDown={(e) => {
                  stopGridClick(e);
                  handleClickLIONResult(props.data);
                }}
              >
                <img
                  src={leftArrow}
                  alt="Log In Icon"
                  height={34}
                  width={34}
                  className="icon"
                />
              </button>
            </span>
          )}
        {/* {props.data.Product == "STAAR"
          &&
          <span className="leftArrow">
            <img
              src={leftArrow}
              alt="Log In Icon"
              height={34}
              width={34}
              className="icon"
              onClick={() => handleClickResult(props.data)}
            />
          </span>
        } */}
      </div>
    );
  };

  const renderYearSelect = () => {
    // if (activeTabs != "Details") {
    if (yearFilter.length > 0) {
      return (
        <div
          className="form-group"
          style={{ marginBottom: "15px", marginLeft: "10px" }}
        >
          <label htmlFor="schoolYear" style={{ fontWeight: "bold" }}>
            School Year :
          </label>
          <select
            id="schoolYear"
            value={currentYear}
            onChange={handleSelectedYear}
            style={{
              maxWidth: "300px",
              padding: "8px",
              marginLeft: "10px",
              borderRadius: "5px",
            }}
          >
            {yearFilter.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>
      );
    }
    //}
    return null;
  };

  // const closePopup = () => {
  //   setIsPopupOpen(false);
  // };

  // DATE COMPARATOR FOR SORTING
  function dateComparator(date1, date2) {
    var date1Number = _monthToNum(date1);
    var date2Number = _monthToNum(date2);

    if (date1Number === null && date2Number === null) {
      return 0;
    }
    if (date1Number === null) {
      return -1;
    }
    if (date2Number === null) {
      return 1;
    }

    return date1Number - date2Number;
  }

  // HELPER FOR DATE COMPARISON
  function _monthToNum(date) {
    if (date === undefined || date === null || date.length !== 10) {
      return null;
    }

    var yearNumber = date.substring(6, 10);
    var monthNumber = date.substring(0, 2);
    var dayNumber = date.substring(3, 5);

    var result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
    // 29/08/2004 => 20040829
    return result;
  }

  // DATA FORMATTING
  function dateFormatter(params) {
    var dateAsString = params.value;
    var dateParts = dateAsString.split("-");
    return `${dateParts[0]}/${dateParts[1]}/${dateParts[2]}`;
  }

  const AssessmentNameWithIcon = (props) => {
    const isReadOnly = seAccessReadOnly || sessionStorage.getItem("SEAccessReadOnly") === "true";
    
    const etazoLogin = () => {
      if (isReadOnly) return; // Don't proceed if read-only
      const { data } = props;
      let districtID = sessionStorage.getItem("districtID");
      let assessmentID = data.AssessmentCode + "Bypass";
      let studentID = studntIdData;
      let currentdate = new Date();
      let datetime = currentdate.getFullYear() + "-"
        + (currentdate.getMonth() + 1) + "-"
        + currentdate.getDate() + " "
        + currentdate.getHours() + ":"
        + currentdate.getMinutes() + ":"
        + currentdate.getSeconds();
      const match = DOB?.match(/\d{4}-\d{2}-\d{2}/);
      if (!match) {
        return;
      }
      const [birthYear, birthMonth, birthDay] = match[0].split("-");
      let a = document.createElement('a');
      a.target = '_blank';
      a.href = 'https://etazo.tangosoftware.com/EtazoLogin/AutoStudentCompanionOnlineLogin?DistrictID=' + districtID + '&AssessmentID=' + assessmentID + '&StudentID=' + studentID + '&ClientTime=' + datetime + '&month=' + birthMonth + '&day=' + birthDay + '&year=' + birthYear;
      a.click();
    }
    let formattedTitle = props.data.Title.replace(/^:\s*/, "");
    return (
      <div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <button
            type="button"
            style={{ ...iconButtonStyle, marginRight: "8px" }}
            onPointerDown={(e) => {
              stopGridClick(e);
              fetchCompanionQuestions(props.data);
            }}
          >
            <img
              src={require("../icons/pdficon.png")}
              alt="PDF Icon"
              height={20}
              width={20}
            />
          </button>

          {props.data.EtazoCompanionQuestionLink === 1 && (
            <button
              type="button"
              style={{ 
                ...iconButtonStyle, 
                marginRight: "8px",
                opacity: isReadOnly ? 0.5 : 1,
                cursor: isReadOnly ? "not-allowed" : "pointer"
              }}
              disabled={isReadOnly}
              title={isReadOnly ? "Access is read-only" : "Online Companion"}
              onPointerDown={(e) => {
                stopGridClick(e);
                if (!isReadOnly) {
                  etazoLogin();
                }
              }}
            >
              <img
                src={require("../icons/OnlineCompanion.png")}
                title="Online Companion"
                height={20}
                width={20}
              />
            </button>
          )}
          <span>{formattedTitle}</span>
        </div>
      </div>
    );
  };

  const overlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  };

  const spinnerStyle = {
    width: "50px",
    height: "50px",
    border: "5px solid #ccc",
    borderTop: "5px solid #007bff",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  };

  const [intValue, setIntValue] = useState(null);

  const [columnDefs, setColumnDefs] = useState([]);

  const [columnDefsLIONMath, setColumnDefsLIONMath] = useState([]);

  const [columnDefsLIONEarlyReading, setColumnDefsLIONEarlyReading] = useState([]);

  useEffect(() => {
    setColumnDefs([
      {
        field: "actions",
        headerName: selectedProduct === "LION" ? "Details" : "Details", // Dynamically set header name based on selectedProduct
        cellStyle: { textAlign: "center", alignItems: "center" },
        cellRenderer: resultDetail,
        //flex: 1,
        width: 80,
      },
      {
        headerName: selectedProduct === "LION" ? "Assessment Type" : "Category",
        field: "AsmtCatg",
        headerClass: "custom-header",
        cellStyle: { textAlign: "left" },
        cellClass: "custom-cell",
        flex: 1,
        minWidth: selectedProduct === "LION" ? 180 : selectedProduct === "CPALLS" ? 250 : 110,
        filter: true,
        filterParams: {
          buttons: ["reset", "cancel"],
          closeOnApply: true,
        },
      },
      {
        headerName: selectedProduct === "KENTRO" ? "Submitted Date" : selectedProduct === "LION" ? "Assessment Date" : "Release Date",
        field: selectedProduct === "KENTRO" ? "SubmittedDate" : selectedProduct === "LION" ? "ReleaseDate" : "ReleaseDate",
        headerClass: "custom-header",
        cellStyle: { textAlign: "center" },
        cellClass: "custom-cell",
        flex: 2,
        minWidth: 180,
        filter: true,
        sort: "desc",
        valueFormatter: (params) => params.value ? dateFormatter(params) : "",
        comparator: dateComparator,
        filter: "agDateColumnFilter",
        floatingFilterComponentParams: {
          suppressFilterButton: true,
        },
        filterParams: {
          debounceMs: 500,
          suppressAndOrCondition: true,
          buttons: ["reset", "cancel"],
          closeOnApply: true,
          comparator: function (filterLocalDateAtMidnight, cellValue) {
            if (cellValue == null) {
              return 0;
            }
            var dateParts = cellValue.split("/");
            var year = Number(dateParts[2]);
            var day = Number(dateParts[1]) - 1;
            var month = Number(dateParts[0]);
            var cellDate = new Date(year, month, day);

            if (cellDate < filterLocalDateAtMidnight) {
              return -1;
            } else if (cellDate > filterLocalDateAtMidnight) {
              return 1;
            } else {
              return 0;
            }
          },
        },
      },
      {
        headerName: selectedProduct === "LION" ? "Assessment Title" : "Title",
        field: "Title",
        headerClass: "custom-header",
        cellRenderer: (params) => {
          if (
            selectedProduct === "KENTRO" &&
            params.data.CompanionQuestionLink
          ) {
            return <AssessmentNameWithIcon {...params} />;
          }
          let formattedTitle = params.value.replace(/^:\s*/, "");
          return formattedTitle;
        },
        cellStyle: {
          textAlign: "start",
          alignItems: "center",
        },
        cellClass: "descWrap",
        flex: 5,
        minWidth: 250,
        filter: true,
        filterParams: {
          buttons: ["reset", "cancel"],
          closeOnApply: true,
        },
      },
      {
        headerName:
          selectedProduct === "LION"
            ? "Genre"
            : selectedProduct === "TPRI/TJL" || selectedProduct === "TPRI"
              ? "Grouping Factor"
              : "Scale Score",
        field: selectedProduct === "LION" ? "Score" : "ScaleScore",
        hide: selectedProduct === "TELPAS" ? true : false,
        headerClass: "custom-header",
        cellStyle: { textAlign: "center", alignItems: "center" },
        cellClass: (params) => {
          return `${params.data.Bucket} custom-cell`;
        },
        cellRenderer: selectedProduct === "LION" ? score : scaleScore,
        flex: 2,
        minWidth: selectedProduct === "LION" ? 100 : selectedProduct === "TPRI/TJL" || selectedProduct === "TPRI" ? 150 : 130,
        filter: true,
        filterParams: {
          buttons: ["reset", "cancel"],
          closeOnApply: true,
        },
        comparator: (num1, num2) => {
          return num1 - num2; // Sorts in ascending order (use num2 - num1 for descending)
        },
      },
      {
        headerName: "Grouping Factor Outcome",
        hide: selectedProduct === "TPRI/TJL" || selectedProduct === "TPRI" ? false : true,
        field: "GroupingFactorOutCome",
        headerClass: "custom-header titleWrap",
        cellClass: (params) => {
          return `${params.data.Bucket} custom-cell`;
        },
        cellStyle: { textAlign: "center", alignItems: "center" },
        flex: 1,
        minWidth: 150,
        filter: true,
        filterParams: {
          buttons: ["reset", "cancel"],
          closeOnApply: true,
        },
        comparator: (num1, num2) => {
          return num1 - num2; // Sorts in ascending order (use num2 - num1 for descending)
        },
      },
      {
        headerName: selectedProduct === "LION" ? "LLL" : "Score",
        hide:
          selectedProduct === "CPALLS" ||
            selectedProduct === "TPRI/TJL" ||
            selectedProduct === "TPRI" ||
            selectedProduct === "TELPAS"
            ? true
            : false,
        field: selectedProduct === "LION" ? "ScaleScore" : "Score",
        headerClass: "custom-header",
        cellStyle: { textAlign: "center", alignItems: "center" },
        cellClass: (params) => {
          return `${params.data.Bucket} custom-cell`;
        },
        cellRenderer: selectedProduct === "LION" ? scaleScore : score,
        flex: 1,
        minWidth: 90,
        filter: true,
        filterParams: {
          buttons: ["reset", "cancel"],
          closeOnApply: true,
        },
        comparator: (num1, num2) => {
          return num1 - num2; // Sorts in ascending order (use num2 - num1 for descending)
        },
      },
      {
        headerName: selectedProduct === "LION" ? "On Grade Level" : selectedProduct === "TPRI/TJL" || selectedProduct === "TPRI" ? "Tier" : "Raw Score",
        hide: selectedProduct === "TELPAS" ? true : false,
        field: "RawScore",
        headerClass: "custom-header",
        cellStyle: selectedProduct === "TPRI/TJL" || selectedProduct === "TPRI" ? (params) => {
          return {
            textAlign: "center",
            alignItems: "center",
            color: params.data.TierColor != null ? "white" : "black",
            backgroundColor: params.data?.TierColor || "transparent",
          };
        } : { textAlign: "center", alignItems: "center" },
        cellClass: (params) => {
          return `${params.data.Bucket} custom-cell`;
        },
        cellRenderer: rawScore,
        flex: 1,
        minWidth: selectedProduct === "LION" ? 150 : 120,
        filter: true,
        filterParams: {
          buttons: ["reset", "cancel"],
          closeOnApply: true,
        },
        comparator: (num1, num2) => {
          return num1 - num2; // Sorts in ascending order (use num2 - num1 for descending)
        },
      },
      {
        headerName: "Band",
        hide:
          selectedProduct === "TPRI/TJL" || selectedProduct === "TPRI"
            ? false
            : true,
        field: "BandDescLong",
        headerClass: "custom-header",
        cellStyle: (params) => {
          return {
            textAlign: "center",
            alignItems: "center",
            color: params.data.BandColorHEX != null ? "white" : "black",
            backgroundColor: params.data?.BandColorHEX || "transparent",
          };
        },
        cellClass: "custom-cell",
        flex: 1,
        minWidth: 150,
        filter: true,
        filterParams: {
          buttons: ["reset", "cancel"],
          closeOnApply: true,
        },
      },
      {
        headerName: "Outcome",
        hide:
          selectedProduct === "KENTRO" || selectedProduct === "STAAR"
            ? false
            : true,
        field: "FormVersion",
        headerClass: "custom-header",
        cellStyle: { textAlign: "center", alignItems: "center" },
        cellClass: (params) => {
          return `${params.data.Bucket} custom-cell`;
        },
        cellRenderer: outCome,
        flex: 1,
        minWidth: 110,
        filter: true,
        filterParams: {
          buttons: ["reset", "cancel"],
          closeOnApply: true,
        },
      },
      {
        headerName: "Composite",
        hide: selectedProduct === "TELPAS" ? false : true,
        field: "CompositeScoreColor",
        cellClass: (params) => {
          return `${params.data.CompositeScoreColor} custom-cell`;
        },
        headerClass: "custom-header",
        cellStyle: { textAlign: "center", alignItems: "center" },
        flex: 1,
        minWidth: 120,
        filter: true,
        filterParams: {
          buttons: ["reset", "cancel"],
          closeOnApply: true,
        },
      },
      {
        headerName: "Reading",
        hide: selectedProduct === "TELPAS" ? false : true,
        field: "ReadingRatingColor",
        cellClass: (params) => {
          return `${params.data.ReadingRatingColor} custom-cell`;
        },
        headerClass: "custom-header",
        cellStyle: { textAlign: "center", alignItems: "center" },
        flex: 1,
        minWidth: 120,
        filter: true,
        filterParams: {
          buttons: ["reset", "cancel"],
          closeOnApply: true,
        },
      },
      {
        headerName: "Writing",
        hide: selectedProduct === "TELPAS" ? false : true,
        field: "WritingRatingColor",
        headerClass: "custom-header",
        cellStyle: { textAlign: "center", alignItems: "center" },
        cellClass: (params) => {
          return `${params.data.WritingRatingColor} custom-cell`;
        },
        flex: 1,
        minWidth: 120,
        filter: true,
        filterParams: {
          buttons: ["reset", "cancel"],
          closeOnApply: true,
        },
      },
      {
        headerName: "Listening",
        hide: selectedProduct === "TELPAS" ? false : true,
        field: "ListeningRatingColor",
        headerClass: "custom-header",
        cellStyle: { textAlign: "center", alignItems: "center" },
        cellClass: (params) => {
          return `${params.data.ListeningRatingColor} custom-cell`;
        },
        flex: 1,
        minWidth: 120,
        filter: true,
        filterParams: {
          buttons: ["reset", "cancel"],
          closeOnApply: true,
        },
      },
      {
        headerName: "Speaking",
        hide: selectedProduct === "TELPAS" ? false : true,
        field: "SpeakingRatingColor",
        headerClass: "custom-header",
        cellStyle: { textAlign: "center", alignItems: "center" },
        cellClass: (params) => {
          return `${params.data.SpeakingRatingColor} custom-cell`;
        },
        flex: 1,
        minWidth: 110,
        filter: true,
        filterParams: {
          buttons: ["reset", "cancel"],
          closeOnApply: true,
        },
      },
    ]);
  }, [selectedProduct]);

  useEffect(() => {
    setColumnDefsLIONMath([
      {
        field: "actions",
        headerName: "Details",
        cellStyle: { textAlign: "center", alignItems: "center" },
        cellRenderer: resultDetail,
        //flex: 1,
        width: 80,
      },
      {
        headerName: "Assessment Type",
        field: "AsmtCatg",
        headerClass: "custom-header",
        cellStyle: { textAlign: "left" },
        cellClass: "custom-cell",
        flex: 1,
        minWidth: 180,
        filter: true,
        filterParams: {
          buttons: ["reset", "cancel"],
          closeOnApply: true,
        },
      },
      {
        headerName: "Assessment Date",
        field: "ReleaseDate",
        headerClass: "custom-header",
        cellStyle: { textAlign: "center" },
        cellClass: "custom-cell",
        flex: 2,
        minWidth: 180,
        filter: true,

        sort: "desc",
        valueFormatter: dateFormatter,
        comparator: dateComparator,
        filter: "agDateColumnFilter",
        floatingFilterComponentParams: {
          suppressFilterButton: true,
        },
        filterParams: {
          debounceMs: 500,
          suppressAndOrCondition: true,
          buttons: ["reset", "cancel"],
          closeOnApply: true,
          comparator: function (filterLocalDateAtMidnight, cellValue) {
            if (cellValue == null) {
              return 0;
            }
            var dateParts = cellValue.split("/");
            var year = Number(dateParts[2]);
            var day = Number(dateParts[1]) - 1;
            var month = Number(dateParts[0]);
            var cellDate = new Date(year, month, day);

            if (cellDate < filterLocalDateAtMidnight) {
              return -1;
            } else if (cellDate > filterLocalDateAtMidnight) {
              return 1;
            } else {
              return 0;
            }
          },
        },
      },
      {
        headerName: "Assessment Title",
        field: "Title",
        headerClass: "custom-header",
        cellRenderer: (params) => {
          let formattedTitle = params.value.replace(/^:\s*/, "");
          return formattedTitle;
        },
        cellStyle: {
          textAlign: "start",
          alignItems: "center",
        },
        cellClass: "descWrap",
        flex: 5,
        minWidth: 250,
        filter: true,
        filterParams: {
          buttons: ["reset", "cancel"],
          closeOnApply: true,
        },
      },
      {
        headerName: "Screening %",
        field: "ScrOverallPerc",
        hide: selectedProduct === "TELPAS" ? true : false,
        headerClass: "custom-header",
        cellStyle: { textAlign: "center", alignItems: "center" },
        cellClass: (params) => {
          return `${params.data.ScreeningColor} custom-cell`;
        },
        //cellRenderer: selectedProduct === "LION" ? score : scaleScore,
        flex: 2,
        minWidth: 130,
        filter: true,
        filterParams: {
          buttons: ["reset", "cancel"],
          closeOnApply: true,
        },
        comparator: (num1, num2) => {
          return num1 - num2; // Sorts in ascending order (use num2 - num1 for descending)
        },
      },
      {
        headerName: "Screening Outcome",
        field: "ScreeningColor",
        headerClass: "custom-header titleWrap",
        cellStyle: { textAlign: "center", alignItems: "center" },
        cellClass: (params) => {
          return `${params.data.ScreeningColor} custom-cell`;
        },
        //cellRenderer: selectedProduct === "LION" ? scaleScore : score,
        flex: 1,
        minWidth: 150,
        filter: true,
        filterParams: {
          buttons: ["reset", "cancel"],
          closeOnApply: true,
        },
        comparator: (num1, num2) => {
          return num1 - num2; // Sorts in ascending order (use num2 - num1 for descending)
        },
      },
      {
        headerName: "Inventory %",
        field: "InvOverallPerc",
        headerClass: "custom-header",
        cellStyle: { textAlign: "center", alignItems: "center" },
        cellClass: (params) => {
          return `${params.data.InventoryColor} custom-cell`;
        },
        //cellRenderer: selectedProduct === "LION" ? scaleScore : score,
        flex: 1,
        minWidth: 130,
        filter: true,
        filterParams: {
          buttons: ["reset", "cancel"],
          closeOnApply: true,
        },
        comparator: (num1, num2) => {
          return num1 - num2; // Sorts in ascending order (use num2 - num1 for descending)
        },
      },
      {
        headerName: "Inventory Outcome",
        field: "InventoryColor",
        headerClass: "custom-header titleWrap",
        cellStyle: { textAlign: "center", alignItems: "center" },
        cellClass: (params) => {
          return `${params.data.InventoryColor} custom-cell`;
        },
        //cellRenderer: selectedProduct === "LION" ? scaleScore : score,
        flex: 1,
        minWidth: 150,
        filter: true,
        filterParams: {
          buttons: ["reset", "cancel"],
          closeOnApply: true,
        },
        comparator: (num1, num2) => {
          return num1 - num2;
        },
      },
    ]);
  }, [selectedProduct]);


  useEffect(() => {
    setColumnDefsLIONEarlyReading([
      {
        field: "actions",
        headerName: "Details",
        cellStyle: { textAlign: "center", alignItems: "center" },
        cellRenderer: resultDetail,
        //flex: 1,
        width: 80,
      },

      {
        headerName: "Assessment Type",
        field: "AsmtCatg",
        headerClass: "custom-header",
        cellStyle: { textAlign: "left" },
        cellClass: "custom-cell",
        flex: 1,
        minWidth: 180,
        filter: true,
        filterParams: {
          buttons: ["reset", "cancel"],
          closeOnApply: true,
        },
      },

      {
        headerName: "Assessment Date",
        field: "ReleaseDate",
        headerClass: "custom-header",
        cellStyle: { textAlign: "center" },
        cellClass: "custom-cell",
        flex: 2,
        minWidth: 155,
        filter: true,

        sort: "desc",
        valueFormatter: dateFormatter,
        comparator: dateComparator,
        filter: "agDateColumnFilter",
        floatingFilterComponentParams: {
          suppressFilterButton: true,
        },
        filterParams: {
          debounceMs: 500,
          suppressAndOrCondition: true,
          buttons: ["reset", "cancel"],
          closeOnApply: true,
          comparator: function (filterLocalDateAtMidnight, cellValue) {
            if (cellValue == null) {
              return 0;
            }
            var dateParts = cellValue.split("/");
            var year = Number(dateParts[2]);
            var day = Number(dateParts[1]) - 1;
            var month = Number(dateParts[0]);
            var cellDate = new Date(year, month, day);

            if (cellDate < filterLocalDateAtMidnight) {
              return -1;
            } else if (cellDate > filterLocalDateAtMidnight) {
              return 1;
            } else {
              return 0;
            }
          },
        },
      },

      {
        headerName: "Assessment Title",
        field: "Title",
        headerClass: "custom-header",
        cellRenderer: (params) => {
          let formattedTitle = params.value.replace(/^:\s*/, "");
          return formattedTitle;
        },
        cellStyle: {
          textAlign: "start",
          alignItems: "center",
        },
        cellClass: "descWrap",
        flex: 5,
        minWidth: 250,
        filter: true,
        filterParams: {
          buttons: ["reset", "cancel"],
          closeOnApply: true,
        },
      },

      {
        headerName: "Overall Score",
        hide: selectedProduct === "TELPAS" ? true : false,
        field: "RawScore",
        headerClass: "custom-header",
        cellStyle: selectedProduct === "TPRI/TJL" || selectedProduct === "TPRI" ? (params) => {
          return {
            textAlign: "center",
            alignItems: "center",
            color: params.data.TierColor != null ? "white" : "black",
            backgroundColor: params.data?.TierColor || "transparent",
          };
        } : { textAlign: "center", alignItems: "center" },
        cellClass: (params) => {
          return `${params.data.BucketColor} custom-cell`;
        },
        cellRenderer: rawScore,
        flex: 1,
        minWidth: selectedProduct === "LION" ? 150 : 120,
        filter: true,
        filterParams: {
          buttons: ["reset", "cancel"],
          closeOnApply: true,
        },
        comparator: (num1, num2) => {
          return num1 - num2; // Sorts in ascending order (use num2 - num1 for descending)
        },
      },

      {
        headerName: "Outcome",

        field: "Bucket",
        headerClass: "custom-header",
        cellStyle: { textAlign: "center", alignItems: "center" },
        cellClass: (params) => {
          return `${params.data.BucketColor} custom-cell`;
        },
        // cellRenderer: outCome,
        flex: 2,
        minWidth: 110,
        filter: true,
        filterParams: {
          buttons: ["reset", "cancel"],
          closeOnApply: true,
        },
      },

    ]);
  }, [selectedProduct]);

  const gridOptions = {
    icons: {
      sortAscending: '<span class="ag-icon ag-icon-desc">▲</span>',
      sortDescending: '<span class="ag-icon ag-icon-asc">▼</span>',
    },
    tooltipShowDelay: 500,
    tooltipHideDelay: 3000,
    stopEditingWhenCellsLoseFocus: false,
  };

  // Result Details
  const getQuestionColor = (assessmentResult, questionId) => {
    const question = assessmentResult.find(
      (item) => item.QuestionId === questionId
    );
    return question ? question["QuestionId!Color"] : "#ffffff";
  };

  const getClassForSEColor = (assessmentResult, questionId) => {
    const question = assessmentResult.find(
      (item) => item.QuestionId === questionId
    );
    return question ? question["SE!Color"] : "default-class";
  };

  const getClassForDOKNumColor = (assessmentResult, questionId) => {
    const question = assessmentResult.find(
      (item) => item.QuestionId === questionId
    );
    return question ? question["DOKNum!Color"] : "default-class";
  };

  const getClassForSeriesColor = (assessmentResult, taskId) => {
    const data = assessmentResult.find((item) => item.TaskId === taskId);
    return data ? data["Series!Color"] : "default-class";
  };

  const getClassForMasteryPercentageColor = (assessmentResult, taskId) => {
    const data = assessmentResult.find((item) => item.TaskId === taskId);
    return data ? data["MasteryPercentage!Color"] : "default-class";
  };

  const [columnDefss, setColumnDefss] = useState([]);

  useEffect(() => {
    const QuestionId = "QuestionId";
    const keyExists = assessmentResult.some((obj) =>
      obj.hasOwnProperty(QuestionId)
    );

    const hasStaarCoefficientData = assessmentResult.some(
      (obj) =>
        obj["StaarCoefficient_Factor"] !== undefined &&
        obj["StaarCoefficient_Factor"] !== null
    );

    if (keyExists) {
      setColumnDefss([
        {
          headerName: "Item",
          field: "QuestionId",
          width: 70,
          cellStyle: (params) => ({
            textAlign: "center",
            alignItems: "center",
            //color: "white",
            // backgroundColor: getQuestionColor(
            //   assessmentResult,
            //   params.data.QuestionId
            // ),
          }),
          //flex: 1,
          comparator: (num1, num2) => num1 - num2,
        },
        {
          headerName: "Item Type",
          field: "ItemType",
          width: 150,
          cellStyle: { textAlign: "start", alignItems: "center" },
          //flex: 1,
          filter: true,
          filterParams: {
            buttons: ["reset", "cancel"],
            closeOnApply: true,
          },
        },
        {
          headerName: "Points",
          field: "Points",
          width: 90,
          cellStyle: { textAlign: "center", alignItems: "center" },
          //flex: 1,
          filter: true,
          filterParams: {
            buttons: ["reset", "cancel"],
            closeOnApply: true,
          },
        },
        {
          headerName: "Item Value",
          field: "ItemValue",
          width: 120,
          cellStyle: { textAlign: "center", alignItems: "center" },
          //flex: 1,
          filter: true,
          filterParams: {
            buttons: ["reset", "cancel"],
            closeOnApply: true,
          },
          valueFormatter: (params) => {
            return params.value ? Math.round(params.value) : "";
          },
        },



        {
          headerName: "Content",
          field: "SE",
          minWidth: 110,
          cellClass: (params) => {
            const className = getClassForSEColor(
              assessmentResult,
              params.data.QuestionId
            );
            return className;
          },
          cellStyle: { textAlign: "center", alignItems: "center" },
          flex: 1,
          filter: true,
          filterParams: {
            buttons: ["reset", "cancel"],
            closeOnApply: true,
          },
        },

        {
          headerName: "Standard",
          field: "TEKSAsmtRelationType",
          minWidth: 110,
          flex: 1,
          cellClass: (params) => {
            const className = getClassForSEColor(
              assessmentResult,
              params.data.QuestionId
            );
            return className;
          },
          cellStyle: { textAlign: "center", alignItems: "center" },
          filter: true,
          filterParams: {
            buttons: ["reset", "cancel"],
            closeOnApply: true,
          },
        },

        // {
        //   headerName: "RC",
        //   field: "RCNum",
        //   minWidth: 80,
        //   cellStyle: { textAlign: "center", alignItems: "center" },
        //   flex: 1,
        // },

        {
          headerName: "SE Description",
          field: "SEDesc",
          minWidth: 230,
          flex: 5,
          cellStyle: {
            textAlign: "start",
            alignItems: "center",
          },
          filter: true,
          filterParams: {
            buttons: ["reset", "cancel"],
            closeOnApply: true,
          },
          cellClass: "descWrap",
          cellRenderer: function (params) {
            let cellValue = params.value;
            let tempDiv = document.createElement("div");
            tempDiv.innerHTML = cellValue;

            let keywordText = "";
            let rubricText = "";
            let remainingText = "";

            let keywordTags = tempDiv.querySelectorAll("Keyword");
            keywordTags.forEach((tag) => {
              keywordText += tag.textContent + " ";
              tag.remove();
            });

            let rubricTags = tempDiv.querySelectorAll("rubricdesc");
            rubricTags.forEach((tag) => {
              rubricText += tag.textContent + " ";
              tag.remove();
            });
            remainingText = tempDiv.textContent.trim();
            return (
              <div>
                {remainingText && <span>{remainingText} </span>}
                {/* {keywordText && (
                  <span style={{ color: "red" }}>{keywordText}</span>
                )}
                {rubricText && (
                  <span style={{ color: "blue" }}>{rubricText}</span>
                )} */}
              </div>
            );
          },
        },

        {
          headerName: "DOK",
          field: "DOKNum",
          minWidth: 100,
          cellClass: (params) => {
            const className = getClassForDOKNumColor(
              assessmentResult,
              params.data.QuestionId
            );
            return className;
          },
          cellStyle: { textAlign: "center", alignItems: "center" },
          flex: 2,
          filter: true,
          filterParams: {
            buttons: ["reset", "cancel"],
            closeOnApply: true,
          },
        },



      ]);
    } else {
      setColumnDefss([
        // {
        //   headerName: "Series",
        //   field: "Series",
        //    minWidth: 120,
        //   cellClass: (params) => {
        //     const className = getClassForSeriesColor(
        //       assessmentResult,
        //       params.data.TaskId
        //     );
        //     return className;
        //   },
        //   cellStyle: { textAlign: "center", alignItems: "center" },
        //   flex: 2,
        // },
        {
          headerName: "Task Name",
          field: "TaskName",
          cellStyle: { textAlign: "start", alignItems: "center" },
          flex: 4,
          minWidth: 210,
          filter: true,
          sort: "asc",
          filterParams: {
            buttons: ["reset", "cancel"],
            closeOnApply: true,
          },
        },
        {
          headerName: "Activity Name",
          field: "TaskLabels",
          cellStyle: { textAlign: "center", alignItems: "center" },
          flex: 2,
          minWidth: 140,
          filter: true,
          filterParams: {
            buttons: ["reset", "cancel"],
            closeOnApply: true,
          },
        },
        {
          headerName: "Standard",
          field: "Skills",
          cellStyle: { textAlign: "center", alignItems: "center" },
          flex: 1,
          minWidth: 110,
          filter: true,
          filterParams: {
            buttons: ["reset", "cancel"],
            closeOnApply: true,
          },
        },
        {
          headerName: "RC",
          field: "ReportingCategory",
          cellStyle: { textAlign: "center", alignItems: "center" },
          flex: 1,
          minWidth: 70,
          filter: true,
          filterParams: {
            buttons: ["reset", "cancel"],
            closeOnApply: true,
          },
        },
        {
          headerName: "Description",
          field: "ExpectationDesc",
          cellStyle: { textAlign: "start", alignItems: "center" },
          flex: 5,
          cellClass: "descWrap",
          minWidth: 300,
          filter: true,
          filterParams: {
            buttons: ["reset", "cancel"],
            closeOnApply: true,
          },
        },
        {
          headerName: "Tango Assessed Coefficient",
          field: "StaarCoefficient_Factor",
          cellStyle: { textAlign: "center", alignItems: "center" },
          flex: 2,
          minWidth: 150,
          headerClass: "titleWrap",
          hide: !hasStaarCoefficientData,
          filter: true,
          filterParams: {
            buttons: ["reset", "cancel"],
            closeOnApply: true,
          },
        },
        {
          headerName: "Items",
          field: "Items",
          minWidth: 90,
          cellStyle: { textAlign: "center", alignItems: "center" },
          flex: 1,
          comparator: (num1, num2) => num1 - num2,
          filter: true,
          filterParams: {
            buttons: ["reset", "cancel"],
            closeOnApply: true,
          },
        },
        {
          headerName: "Mastery",
          field: "MasteryPercentage",
          cellClass: (params) => {
            const className = getClassForMasteryPercentageColor(
              assessmentResult,
              params.data.TaskId
            );
            return className;
          },
          cellStyle: { textAlign: "center", alignItems: "center" },
          flex: 1,
          minWidth: 100,
          filter: true,
          filterParams: {
            buttons: ["reset", "cancel"],
            closeOnApply: true,
          },
        },
      ]);
    }
  }, [assessmentResult]);

  //
  useEffect(() => {
    const studentkey = sessionStorage.getItem("studentkey");
    const districtID = sessionStorage.getItem("districtID");
    const token = sessionStorage.getItem("authToken");
    const headers = {
      Authorization: `Bearer ${token}`, // Include the token in the Authorization header
      "Content-Type": "application/json", // Optional: Define the content type if needed
    };
    if (token != null) {
      axios
        .get(
          baseUrl +
          `Student/GetHelpPageId?studentkey=${studentkey}&districtId=${districtID}&url=${activeTab}`,
          { headers }
        )
        .then((response) => {
          console.log(response);
          const fetchedValue = response.data;
          setIntValue(fetchedValue);
          setGlobalVariable(fetchedValue);
          console.log("Fetched intValue:", fetchedValue);
        })
        .catch((error) => {
          console.error("Error fetching intValue:", error);
        });
    }
  }, []);

  const renderResultsTable = () => {
    if (loadingResults) {
      return (
        <div className="spinner-container">
          <div className="spinner"></div>
          <p>Loading results...</p>
        </div>
      );
    }
    return (
      <div className="StudentResults">
        <div>
          {renderProduct()}
          {selectedProduct != "Details" && (
            <div>
              {renderYearSelect()}
              <div className="tab-content">
                {Object.entries(resultDataSet).length === 0 ? (
                  <p
                    style={{
                      textAlign: "center",
                      fontSize: "18px",
                      fontWeight: "bold",
                      marginTop: "5%",
                    }}
                  >
                    No data available
                  </p>
                ) : (
                  <Accordion defaultActiveKey={0} bordered>
                    {Object.entries(resultDataSet)
                      .sort(([a], [b]) => a.localeCompare(b))
                      .map(([category, itemList], index) => (
                        <Accordion.Panel
                          header={category}
                          eventKey={index}
                          key={index}
                        >
                          <div className="ag-theme-alpine">
                            {category === "Mathematics" && selectedProduct === "LION" ? (
                              <AgGridReact
                                gridOptions={gridOptions}
                                rowData={itemList}
                                columnDefs={columnDefsLIONMath}
                                domLayout="autoHeight"
                                suppressScrollOnNewData={true}
                                enableBrowserTooltips={true}
                                suppressMenuHide={true}
                                popupParent={document.body}
                              />
                            ) : category === "Early Childhood" && selectedProduct === "LION" ? (
                              <AgGridReact
                                gridOptions={gridOptions}
                                rowData={itemList}
                                columnDefs={columnDefsLIONEarlyReading}
                                domLayout="autoHeight"
                                suppressScrollOnNewData={true}
                                enableBrowserTooltips={true}
                                suppressMenuHide={true}
                                popupParent={document.body}
                              />
                            ) : (
                              <AgGridReact
                                gridOptions={gridOptions}
                                rowData={itemList}
                                columnDefs={columnDefs}
                                domLayout="autoHeight"
                                suppressScrollOnNewData={true}
                                enableBrowserTooltips={true}
                                suppressMenuHide={true}
                                popupParent={document.body}
                              />
                            )}

                          </div>
                        </Accordion.Panel>
                      ))}
                  </Accordion>
                )}
              </div>
            </div>
          )}
          {selectedProduct === "Details" && (
            <div>
              {loadingDetail ? (
                <div className="spinner-container">
                  <div className="spinner"></div>
                  <p>Loading details...</p>
                </div>
              ) : (
                true && (
                  <div>
                    <div className="tab-content">
                      <h5>Result for the document : {assessmentDetail.Title}</h5>
                      <div
                        className="ag-theme-alpine"
                        style={{ height: "400px" }}
                      >
                        <AgGridReact
                          domLayout="autoHeight"
                          gridOptions={gridOptions}
                          rowData={assessmentResult}
                          columnDefs={columnDefss}
                          suppressScrollOnNewData={true}
                        />
                      </div>
                    </div>
                  </div>
                )
              )}
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <>
      {isCompanionLoading &&
        ReactDOM.createPortal(
          <div style={overlayStyle}>
            <div style={spinnerStyle}></div>
            <p style={{ color: "#fff", marginTop: "10px" }}>Loading...</p>
          </div>,
          document.body
        )}

      {isCompanionPopupOpen && companionQuestionData && (
        <CompanionQuestions
          show={isCompanionPopupOpen}
          onClose={() => setIsCompanionPopupOpen(false)}
          data={companionQuestionData}
        />
      )}

      <div>{renderResultsTable()}</div>
      {showScrollIndicator && (
        <div
          style={{
            position: "fixed",
            bottom: "20px",
            right: "20px",
            background: "#d0cfcf99",
            color: "white",
            borderRadius: "50%",
            width: "40px",
            height: "40px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "22px",
            zIndex: 9999,
            cursor: "pointer",
            animation: "bounce 1.5s infinite",
          }}
          onClick={() => {
            const scrollContainer = document.querySelector(".main-content");

            if (scrollContainer) {
              scrollContainer.scrollBy({
                top: 200,
                behavior: "smooth",
              });
            }
          }}
        >
          <img
            src={downArrow}
            alt="Scroll down"
            style={{ width: "22px", height: "22px" }}
          />
        </div>
      )}
    </>
  );
};

export default StudentResults;
